import * as uploadActions from './actions';
import uploadEpics from './epics';
import reducer from './reducers';
import * as uploadSelectors from './selectors';
import * as uploadTypes from './types';

export { uploadActions, uploadEpics, uploadSelectors, uploadTypes };

export default reducer;
